<template>
  <section class="snapshots">
    <div class="snapshots__header">
      <div class="empty"></div>
      <span
          class="btn-success btn btn-success text-center"
          @click.prevent="new_snapshot()"
      >
        {{ translate('snapshot.to_add') }}
      </span>
      <div class="filter checkbox">
        <div class="info">
          {{ translate('snapshot.only_successful') }}
        </div>
        <label class="switch" @click.prevent="filter.all = !filter.all">
          <input type="checkbox" v-model="!filter.all">
          <span class="slider round"></span>
        </label>
      </div>
    </div>
    <div class="response_table">
      <table>
        <thead>
          <tr>
            <th scope="col"> ID </th>
            <th scope="col"> Client </th>
            <th scope="col"> Order name </th>
            <th scope="col"> Username </th>
            <th scope="col"> Status </th>
            <th scope="col"> TS </th>
          </tr>
        </thead>
        <tbody>
          <tr
              v-for="(snapshot, snapshot_key) in snapshot_list"
              :key="snapshot_key"
              @click="show_modal(snapshot)"
          >
            <td data-label="ID" >
              {{snapshot.id}}
            </td>
            <td data-label="Client" >
              {{snapshot.client_name}}
            </td>
            <td data-label="Order name" @click.stop.prevent="">
              <router-link :to="'/client_order/' + snapshot.order_id">
                {{snapshot.order_name}}
              </router-link>
            </td>
            <td data-label="Username" >
              {{snapshot.user_name}}
            </td>
            <td data-label="Status" >
              {{snapshot.status}}
            </td>
            <td data-label="TS" >
              {{get_date(snapshot.created_at)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import SnapshotsModal from '../../../../../SnapshotList/Modal/Index.vue'
import NewSnapshot from "./New/Index.vue";

export default {
  name: 'SnapshotsList',
  props: ['profile'],

  data(){
    return {
      snapshot_list: [],
      filter:{
        all: false
      }
    }
  },
  created() {
    this.init()
  },
  watch:{
    "filter":{
      deep: true,
      handler(){
        this.init()
      }
    }
  },
  methods: {
    check_snapshot() {
      if (this.$route.query.snapshot_id) {
        this.snapshot_list.forEach((snapshot_item) => {
          if (snapshot_item.id === Number(this.$route.query.snapshot_id)){
            this.show_modal(snapshot_item)
          }
        })
      }
    },
    take_snapshot(params){
      if (params.client_order_id === ''){
        params.client_order_id = null
      }
      this.$http.v1.takeDeviceSnapshot( this.profile.id, {...params} ,() => {
        this.global_notify('info', this.translate('snapshot.new_snapshot_success'))
        this.init()
      })
    },
    init(){
      let filter = {
        id: this.profile.id,
        all: this.filter.all ? 1 : 0
      }
      this.$http.v1.getDeviceSnapshotsList(filter, (response) => {
        this.snapshot_list = response.data
        this.check_snapshot()
      })
    },
    show_modal(data){
      let t = this.$createElement(SnapshotsModal, {
        props: {
          data
        },
        on: {
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', width: 800, adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
    new_snapshot(){
      let t = this.$createElement(NewSnapshot, {
        props: {
          profile_id: this.profile.id,
          fid: this.profile.fid,
        },
        on: {
          take: (param) => {
            this.take_snapshot(param);
            this.$modal.hide('dynamic-modal');
          },
          close: () => {this.$modal.hide('dynamic-modal') }
        }
      })
      let temp = { render () { return t } }
      this.$modal.show(temp, {}, {height: 'auto', adaptive: true, clickToClose: true, scrollable: true, name: 'dynamic-modal'})
    },
  }
}
</script>

<style lang="scss" scoped>
  .snapshots {
    height: 100%;
    width: 100%;
    &__header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 18px;
      height: 50px;
      padding-top: 0;
      padding-bottom: 10px;
      .btn{
        height: 40px;
      }
      .empty{
        min-width: 200px;
      }
    }
    .response_table{
      padding: 0;
      height: calc(100% - 50px);
      th{
        font-size: 12px;
      }
      tbody{
        tr{
          cursor: pointer;
          font-size: 12px;
          &:hover{
            background-color: #f1f1f1;
          }
        }
      }
    }
  }
</style>
